import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";
import { renderGlobalModal } from "../../../utils/helpers";

// ===============================
// THUNK: Load My Mentors
// ===============================
export const loadMyMentors = createAsyncThunk(
  "myMentors/loadMyMentors",
  async ({ request, userId }, { rejectWithValue }) => {
    try {
      const response = await agent.get(
        `${API.LOAD_MY_MENTORS}/${userId}`,
        { params: request }
      );

      const data = response?.data?.data?.data || [];
      const pagination = response?.data?.data?.pagination || {};

      return { data, pagination };
    } catch (error) {
      renderGlobalModal({
        message: error?.message || "Something went wrong",
      });
      return rejectWithValue(error?.message);
    }
  }
);

export const loadRegMyMentors = createAsyncThunk(
  "myMentors/loadRegMyMentors",
  async ({ request, userId, roleId }, { rejectWithValue }) => {
    try {
      const response = await agent.get(
        `${API.LOAD_REG_MY_MENTORS}/${userId}/${roleId}?type=view_my_mentor`,
        { params: request }
      );

      const data = response?.data?.data?.data || [];
      const pagination = response?.data?.data?.pagination || {};
      const steps_labels = response?.data?.data?.steps_labels || {};

      return { data, pagination, steps_labels };
    } catch (error) {
      renderGlobalModal({
        message: error?.message || "Something went wrong",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// ===============================
// SLICE
// ===============================
const myMentorsSlice = createSlice({
  name: "myMentors",

  initialState: {
    menteeRequestData: [],
    steps_labels: {},
    pagination: {},
    loading: false,
    notFound: false,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      // LOAD START
      .addCase(loadMyMentors.pending, (state) => {
        state.loading = true;
      })

      // LOAD SUCCESS
      .addCase(loadMyMentors.fulfilled, (state, action) => {
        state.loading = false;

        const { data, pagination } = action.payload;

        state.menteeRequestData = data;
        state.pagination = pagination;
        state.notFound = data.length === 0;
      })

      // LOAD ERROR
      .addCase(loadMyMentors.rejected, (state) => {
        state.loading = false;
        state.notFound = true;
      })
      .addCase(loadRegMyMentors.pending, (state) => {
        state.loading = true;
      })

      // LOAD SUCCESS
      .addCase(loadRegMyMentors.fulfilled, (state, action) => {
        state.loading = false;

        const { data, pagination, steps_labels } = action.payload;

        state.menteeRequestData = data;
        state.steps_labels = steps_labels;
        state.pagination = pagination;
        state.notFound = data.length === 0;
      })

      // LOAD ERROR
      .addCase(loadRegMyMentors.rejected, (state) => {
        state.loading = false;
        state.notFound = true;
      });
  },
});

export default myMentorsSlice.reducer;
